import ApiFactory from '@/factories/ApiFactory';

const channelPath = (channelName) => `businesschats/v1/channels/${encodeURIComponent(channelName)}`;

const PHOTO_TIMEOUT_MS = 60000;

export const createChat = ({ channelName, orderCode }) =>
	new Promise((resolve, reject) => {
		ApiFactory.post(`${channelPath(channelName)}/orders/${encodeURIComponent(orderCode)}/chats`)
			.then(({ data }) => {
				const chatId = data?.data;
				if (typeof chatId === 'string' && chatId !== '') {
					resolve(chatId);
				} else {
					reject(null);
				}
			})
			.catch((error) => reject(error));
	});

export const sendChatMessage = ({ channelName, chatId, text, imageDataUrl }) =>
	new Promise((resolve, reject) => {
		ApiFactory.post(
			`${channelPath(channelName)}/chats/${encodeURIComponent(chatId)}/messages`,
			{
				text: typeof text === 'string' ? text : '',
				imageJson: imageDataUrl ? { stringBase64: imageDataUrl } : null,
			},
			imageDataUrl ? { timeout: PHOTO_TIMEOUT_MS } : undefined
		)
			.then(({ data }) => resolve(data?.data ?? null))
			.catch((error) => reject(error));
	});

export const closeChat = ({ channelName, chatId }) =>
	new Promise((resolve, reject) => {
		ApiFactory.put(`${channelPath(channelName)}/chats/${encodeURIComponent(chatId)}/close`)
			.then(({ data }) => resolve(data?.data ?? null))
			.catch((error) => reject(error));
	});

export const rateChat = ({ channelName, chatId, value }) =>
	new Promise((resolve, reject) => {
		ApiFactory.put(`${channelPath(channelName)}/chats/${encodeURIComponent(chatId)}/rate/${value}`)
			.then(({ data }) => resolve(data?.data ?? null))
			.catch((error) => reject(error));
	});
